import { LIGHTER_GREY } from '../theme/color';

export const overrides = {
    MuiChip: {
        root: {
            backgroundColor: LIGHTER_GREY
        }
    }
};
